export default {

  user_troubleshooting_tab_title: "User Troubleshooting",
  user_troubleshooting_tab_filter_by_last: "Last",
  user_troubleshooting_tab_filter_by_date: "Range",
  user_troubleshooting_tab_apply_filters: "Apply",
  
  user_troubleshooting_tab_date_range: "Please select a valid date range",
  user_troubleshooting_tab_raw_message: "Raw Message",

  user_troubleshooting_tab_warning: "Warning",
  user_troubleshooting_tab_created_on: "Created On",
  user_troubleshooting_installed: "Installed",
  user_troubleshooting_sim_status: "SIM Status",
  user_troubleshooting_gps: "GPS",  
  user_troubleshooting_tab_details: "Details",
  user_troubleshooting_tab_passed: "Passed",
  user_troubleshooting_tab_fail: "Fail",
  user_troubleshooting_odo_engine: "Odometer/Engine Hours"
}
